import React from 'react';
import { shape } from 'prop-types';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Grid from '@magalu/stereo-ui/atoms/Grid';
import Text from '@magalu/stereo-ui/atoms/Text';
import Button from '@magalu/stereo-ui/atoms/Button';
import { usePublisher } from '@magalu/mixer-publisher';
import { PromoterAvatar, CapitalizedText } from '../../PromoterHeader.style';
var PromoterHeaderMinimal = function PromoterHeaderMinimal(_ref) {
  var staticProps = _ref.staticProps,
    structure = _ref.structure;
  var store = staticProps.store,
    isMobile = staticProps.isMobile,
    minimalButton = staticProps.minimalButton;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var renderButton = function renderButton(render) {
    if (!minimalButton || !render) return null;
    var openShareLinksModal = function openShareLinksModal() {
      publish('sharelinksbutton:click');
      publish('pmd:sharelinks:generate:link:click', {
        pageType: structure == null ? void 0 : structure.name,
        productId: structure == null ? void 0 : structure.route.productId,
        productName: isMobile ? structure == null ? void 0 : structure.route.productSlug : structure == null ? void 0 : structure.route.slug
      });
    };
    var buttonProps = {
      centered: true,
      'data-testid': "phm-button-".concat(isMobile ? 'mobile' : 'desktop'),
      full: !!isMobile,
      ml: 'auto',
      mt: isMobile ? 3 : 0,
      onClick: openShareLinksModal,
      startIcon: minimalButton == null ? void 0 : minimalButton.icon,
      type: 'submit',
      uppercase: false,
      variation: 'primary'
    };
    return React.createElement(Button, buttonProps, minimalButton == null ? void 0 : minimalButton.text);
  };
  return React.createElement(Grid, {
    gridTemplateColumns: "minmax(8px, 1fr) minmax(auto, 1366px) minmax(8px, 1fr)",
    gridTemplateRows: "minmax(86px, auto)",
    gridTemplateAreas: " '. content .' ",
    style: {
      alignItems: 'center'
    },
    "data-testid": "promoter-header-minimal"
  }, React.createElement(Grid, {
    gridArea: "content",
    padding: "16px 0"
  }, React.createElement(Flex, {
    alignItems: "center",
    gap: 3
  }, React.createElement(PromoterAvatar, {
    src: store == null ? void 0 : store.image,
    alt: "Imagem de perfil do Divulgador",
    size: "50px",
    margin: "0"
  }), React.createElement(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    height: "50px",
    gap: 2
  }, React.createElement(CapitalizedText, {
    fontSize: 4,
    fontWeight: "bold"
  }, store == null ? void 0 : store.name), React.createElement(Text, {
    fontSize: 2
  }, "Influenciador Magalu")), renderButton(!isMobile)), renderButton(!!isMobile)));
};
process.env.NODE_ENV !== "production" ? PromoterHeaderMinimal.propTypes = {
  staticProps: shape({}),
  structure: shape({})
} : void 0;
PromoterHeaderMinimal.defaultProps = {
  staticProps: {},
  structure: {}
};
export default PromoterHeaderMinimal;